import AlbumContent from './AlbumContent'

export default AlbumContent
